module.exports = __webpack_public_path__ + "img/Asset_Tarjetas.0b9a085a.png";